import { defineComponent as _defineComponent } from 'vue'
import { isNavigationFailure, NavigationFailureType } from 'vue-router';
import { useRouter } from 'vue-router/composables';
import type { ObjectType } from '@/@types/graphql-types';

import { computed } from 'vue';

interface MinimumLinkTitle {
	objectId: number;
	objectType: ObjectType;
	content: {
		title: string;
		originalReleaseYear?: number | null;
	};
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailLink',
  props: {
    title: null,
    fullPath: null
  },
  emits: ['clickOut', 'click'],
  setup(__props: any, { emit }) {

const props = __props as { title: MinimumLinkTitle; fullPath: string };

const router = useRouter();




const isExternalLink = computed(() => /^(http|https|www)/i.test(props.fullPath));

async function navigate(evt: MouseEvent, fullPath: string) {
	evt.preventDefault();
	emit('click');

	// INP case: artificially give the JS thread time to breathe by adding a re-render.
	await new Promise(resolve => setTimeout(resolve, 0));

	router.push(fullPath).catch((error: any) => {
		if (
			!isNavigationFailure(error, NavigationFailureType.duplicated) &&
			!isNavigationFailure(error, NavigationFailureType.cancelled)
		) {
			throw error;
		}
	});
}

// Open up modal if title doesn't have a fullPath.
// That means it exists but doesn't have an URL in this country.
//
// DO NOT USE `async` on this function.
// Used together with dynamic imports, it will stop vue's (click) event bubbling.
function onClick(title: MinimumLinkTitle) {
	emit('click');

	Promise.all([
		import('@/components/modals/TitleDetailModal.vue'),
		import('@/helpers/modal-helper'),
		import('@/helpers/entity-helper'),
	]).then(([{ default: TitleDetailModal }, { ModalHelper, getCtr }, { getTitleContextEntityId }]) => {
		getCtr()
			.then(ctr => ctr.getTop())
			.then(modal => {
				// close other open modals
				modal?.dismiss();

				// open title detail modal
				ModalHelper.openModal(
					TitleDetailModal,
					{
						entityId: getTitleContextEntityId(title.objectType, title.objectId, 'TitleDetailLink'),
						titleName: title.content.title,
						releaseYear: title.content.originalReleaseYear,
					},
					{ cssClass: 'jw-title-detail-modal' }
				);
			});
	});
}

return { __sfc: true,router, props, emit, isExternalLink, navigate, onClick }
}

})